// // dynamic build size


// import React, { useEffect, useRef, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import Navbar from '../Navbar';
// import axios from 'axios';

// const roomBaseUrls = {
//   beach: 'https://plutonichealth.co/beach',
//   mountain: 'https://plutonichealth.co/forest',
//   // forest: 'https://plutonichealth.co/forest',
//   park: 'https://plutonichealth.co/park',
//   "park-therapy": "https://plutonichealth.co/park",
//   "beach-therapy": "https://plutonichealth.co/beach",
//   "forest-therapy": "https://plutonichealth.co/forest",

// };

// function UnityRoom({ setCurrentNickname, currentNickname, handleLogout, setFormType }) {
//   const navigate = useNavigate();

//   const { roomType } = useParams();
//   const [roomUrl, setRoomUrl] = useState('');
//   const [roomId, setRoomId] = useState('');
//   const [userId, setUserId] = useState('');
//   const [isValidSession, setIsValidSession] = useState(false); // Track session validity
//   const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  

  
  

//   useEffect(() => {
//     const savedRoomId = sessionStorage.getItem('meetingID');
//     const savedUserId = sessionStorage.getItem('userId');

//     // Log session data for debugging
//     // console.log("[UnityRoom] Session Data:");
//     // console.log("  - roomType:", roomType);
//     // console.log("  - savedRoomId:", savedRoomId);
//     // console.log("  - savedUserId:", savedUserId);
//     // console.log("  - roomBaseUrls[roomType]:", roomBaseUrls[roomType]);

//     if (savedRoomId && savedUserId && roomType && roomBaseUrls[roomType]) {
//       setRoomId(savedRoomId);
//       setUserId(savedUserId);
//       setRoomUrl(`${roomBaseUrls[roomType]}?roomId=${savedRoomId}&userId=${savedUserId}`);
//       setIsValidSession(true);
//     } else {
//       console.warn('[UnityRoom] Missing or invalid session data.');
//       setIsValidSession(false);
//       navigate('/therapy-rooms'); // Redirect if the session is invalid
//     }
//   }, [roomType, navigate]);


//   useEffect(() => {
//     const setupUnityCommunication = () => {
//       const unityIframe = document.getElementById('unity-iframe');
//       if (!unityIframe) {
//         console.error('[UnityRoom] Unity iframe not found.');
//         return;
//       }

//       console.log('[UnityRoom] Unity iframe found. Setting up communication...');

//       // *** Ensure handleUnityMessage is defined properly ***
//       const handleUnityMessage = async (event) => {
//         console.log('[UnityRoom] Message received from Unity:', event.data, 'from origin:', event.origin);

//         const trustedOrigins = ['https://plutonichealth.co', 'http://localhost:3000'];
//         if (!trustedOrigins.includes(event.origin)) {
//           console.warn('[UnityRoom] Untrusted origin:', event.origin);
//           return;
//         }

//         if (event.data?.type === 'unityReady') {
//           console.log('[UnityRoom] Unity is ready to receive data!');
//           const message = JSON.stringify({ userId, roomId }); // Serialize the message
//           console.log('[UnityRoom] Sending serialized message to Unity:', message);

//           if (unityIframe.contentWindow) {
//             unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
//           } else {
//             console.error('[UnityRoom] contentWindow is null. Cannot send message.');
//           }
//         }
        
//         // *** Handle leaveSession event ***
//         else if (event.data?.type === 'leaveSession') {
//           console.log('[UnityRoom] User is leaving the session. Setting online status to false.');

//           if (userId && roomId) {
//               try {
//                   await axios.post(
//                       `${process.env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`,
//                       { meetingID: roomId, online: false }
//                   );
//                   // console.log('[UnityRoom] Online status updated successfully.');
//               } catch (error) {
//                   // console.error('[UnityRoom] Failed to update online status:', error);
//               }
//           } else {
//               console.warn('[UnityRoom] Missing userId or roomId. Cannot update online status.');
//           }

//           setRoomsOnlineStatus(false);
//           navigate('/therapy-rooms');
//         } 

//         else {
//           console.warn('[UnityRoom] Received unexpected message type:', event.data?.type);
//         }
//       };

//       window.addEventListener('message', handleUnityMessage);

//       return () => {
//         window.removeEventListener('message', handleUnityMessage);
//       };
//     };

//     if (isValidSession) {
//       const observer = new MutationObserver(() => {
//         if (document.getElementById('unity-iframe')) {
//           setupUnityCommunication();
//           observer.disconnect(); // Stop observing once iframe is found
//         }
//       });

//       observer.observe(document.body, { childList: true, subtree: true });

//       return () => observer.disconnect();
//     }
// }, [isValidSession, roomId, userId]);


//   useEffect(() => {
//     // Save roomId and userId to sessionStorage when they change
//     if (roomId && userId) {
//       sessionStorage.setItem('meetingID', roomId); // Ensure saved as meetingID for backward compatibility
//       sessionStorage.setItem('userId', userId);
//     }
//   }, [roomId, userId]);

//   const navbarRef = useRef(null);
//   const [iframeStyle, setIframeStyle] = useState({
//     top: '0px',
//     height: '100vh'
//   });

//   useEffect(() => {
//     const updateIframeStyle = () => {
//       const navHeight = navbarRef.current?.offsetHeight || 96;
//       setIframeStyle({
//         top: `${navHeight}px`,
//         height: `calc(100vh - ${navHeight}px)`
//       });
//     };

//     updateIframeStyle();
//     window.addEventListener('resize', updateIframeStyle);
//     return () => window.removeEventListener('resize', updateIframeStyle);
//   }, []);

//   if (!isValidSession) {
//     return (
//       <div style={{
//         width: '100%', height: '100vh', display: 'flex',
//         justifyContent: 'center', alignItems: 'center'
//       }}>
//         <p>Session data is missing or invalid. Please navigate back to the Therapy Rooms.</p>
//       </div>
//     );
//   }
  
  
  

//   // if (!isValidSession) {
//   //   return (
//   //     <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//   //       <p>Session data is missing or invalid. Please navigate back to the Therapy Rooms.</p>
//   //     </div>
//   //   );
//   // }

// //   return (
// //     <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
    
  
// //       <Navbar
// //         setCurrentNickname={setCurrentNickname}
// //         currentNickname={currentNickname}
// //         setFormType={setFormType}
// //         handleLogout={handleLogout}
// //         showButtons={true}
// //         PlutonicuserID={userId}
// //       />

// //       {/* <div style={{ flex: '0 0 120px' }}></div> Adds exactly 20px of space above the iframe */}

// //       {roomUrl ? (
// //         <iframe
// //           id="unity-iframe"
// //           src={roomUrl}
// //           style={{ flex: 1, width: '100%', border: 'none' }}
          
// //           title="Unity WebGL Build"
// //           allow="fullscreen; camera; microphone; display-capture"
// //           onLoad={() => {
// //             console.log('[UnityRoom] Iframe loaded. Ready to send messages.');
// //             const unityIframe = document.getElementById('unity-iframe');
// //             if (unityIframe && unityIframe.contentWindow) {
// //               const message = JSON.stringify({ userId, roomId }); // Serialize the message
// //               console.log('[UnityRoom] Sending serialized message to Unity on load:', message);
// //               unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
// //             }
// //           }}
// //         />

// //       ) : (
// //         <p>Loading Unity Room...</p>
// //       )}
// //     </div>
// //   );
// // }

// // export default UnityRoom;



// return (
//   <div style={{
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100vw',
//     height: '100vh',
//     margin: 0,
//     padding: 0,
//     overflow: 'hidden'
//   }}>
//     <div ref={navbarRef}>
//       <Navbar
//         setCurrentNickname={setCurrentNickname}
//         currentNickname={currentNickname}
//         setFormType={setFormType}
//         handleLogout={handleLogout}
//         showButtons={true}
//         PlutonicuserID={userId}
//       />
//     </div>

//     {roomUrl ? (
//       <iframe
//         id="unity-iframe"
//         src={roomUrl}
//         style={{
//           position: 'absolute',
//           top: iframeStyle.top,
//           left: '0',
//           width: '100vw',
//           height: iframeStyle.height,
//           border: 'none',
//           display: 'block',
//           overflow: 'hidden'
//         }}
//         title="Unity WebGL Build"
//         allow="fullscreen; camera; microphone; display-capture"
//         onLoad={() => {
//           console.log('[UnityRoom] Iframe loaded. Ready to send messages.');
//           const unityIframe = document.getElementById('unity-iframe');
//           if (unityIframe?.contentWindow) {
//             const message = JSON.stringify({ userId, roomId });
//             unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
//           }
//         }}
//       />
//     ) : (
//       <p>Loading Unity Room...</p>
//     )}
//   </div>
// );
// }

// export default UnityRoom;


//final


import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import axios from 'axios';
import Env from '../../runtimeEnv';


const roomBaseUrls = {
  beach: 'https://plutonichealth.co/beach',
  mountain: 'https://plutonichealth.co/forest',
  // forest: 'https://plutonichealth.co/forest',
  park: 'https://plutonichealth.co/park',
  "park-therapy": "https://plutonichealth.co/park",
  "beach-therapy": "https://plutonichealth.co/beach",
  "forest-therapy": "https://plutonichealth.co/forest",

};

function UnityRoom({ setCurrentNickname, currentNickname, handleLogout, setFormType }) {
  const navigate = useNavigate();

  const { roomType } = useParams();
  const [roomUrl, setRoomUrl] = useState('');
  const [roomId, setRoomId] = useState('');
  const [userId, setUserId] = useState('');
  const [isValidSession, setIsValidSession] = useState(false); // Track session validity
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  

  
  

  useEffect(() => {
    const savedRoomId = sessionStorage.getItem('meetingID');
    const savedUserId = sessionStorage.getItem('userId');

    // Log session data for debugging
    // console.log("[UnityRoom] Session Data:");
    // console.log("  - roomType:", roomType);
    // console.log("  - savedRoomId:", savedRoomId);
    // console.log("  - savedUserId:", savedUserId);
    // console.log("  - roomBaseUrls[roomType]:", roomBaseUrls[roomType]);

    if (savedRoomId && savedUserId && roomType && roomBaseUrls[roomType]) {
      setRoomId(savedRoomId);
      setUserId(savedUserId);
      setRoomUrl(`${roomBaseUrls[roomType]}?roomId=${savedRoomId}&userId=${savedUserId}`);
      setIsValidSession(true);
    } else {
      console.warn('[UnityRoom] Missing or invalid session data.');
      setIsValidSession(false);
      navigate('/therapy-rooms'); // Redirect if the session is invalid
    }
  }, [roomType, navigate]);


  useEffect(() => {
    const setupUnityCommunication = () => {
      const unityIframe = document.getElementById('unity-iframe');
      if (!unityIframe) {
        console.error('[UnityRoom] Unity iframe not found.');
        return;
      }

      console.log('[UnityRoom] Unity iframe found. Setting up communication...');

      // *** Ensure handleUnityMessage is defined properly ***
      const handleUnityMessage = async (event) => {
        console.log('[UnityRoom] Message received from Unity:', event.data, 'from origin:', event.origin);

        const trustedOrigins = ['https://plutonichealth.co', 'http://localhost:3000'];
        if (!trustedOrigins.includes(event.origin)) {
          console.warn('[UnityRoom] Untrusted origin:', event.origin);
          return;
        }

        if (event.data?.type === 'unityReady') {
          console.log('[UnityRoom] Unity is ready to receive data!');
          const message = JSON.stringify({ userId, roomId }); // Serialize the message
          console.log('[UnityRoom] Sending serialized message to Unity:', message);

          if (unityIframe.contentWindow) {
            unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
          } else {
            console.error('[UnityRoom] contentWindow is null. Cannot send message.');
          }
        }
        
        // *** Handle leaveSession event ***
        else if (event.data?.type === 'leaveSession') {
          console.log('[UnityRoom] User is leaving the session. Setting online status to false.');

          if (userId && roomId) {
              try {
                  await axios.post(
                      `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`,
                      { meetingID: roomId, online: false }
                  );
                  // console.log('[UnityRoom] Online status updated successfully.');
              } catch (error) {
                  // console.error('[UnityRoom] Failed to update online status:', error);
              }
          } else {
              console.warn('[UnityRoom] Missing userId or roomId. Cannot update online status.');
          }

          setRoomsOnlineStatus(false);
          navigate('/therapy-rooms');
        } 

        else {
          console.warn('[UnityRoom] Received unexpected message type:', event.data?.type);
        }
      };

      window.addEventListener('message', handleUnityMessage);

      return () => {
        window.removeEventListener('message', handleUnityMessage);
      };
    };

    if (isValidSession) {
      const observer = new MutationObserver(() => {
        if (document.getElementById('unity-iframe')) {
          setupUnityCommunication();
          observer.disconnect(); // Stop observing once iframe is found
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      return () => observer.disconnect();
    }
}, [isValidSession, roomId, userId]);


  useEffect(() => {
    // Save roomId and userId to sessionStorage when they change
    if (roomId && userId) {
      sessionStorage.setItem('meetingID', roomId); // Ensure saved as meetingID for backward compatibility
      sessionStorage.setItem('userId', userId);
    }
  }, [roomId, userId]);

  // // Handle tab close to set online status to false
  // useEffect(() => {
  //   const handleTabClose = () => {
  //     if (roomId && userId) {
  //       const payload = JSON.stringify({ meetingID: roomId, online: false });
  //       console.log('[UnityRoom] Sending tab close payload:', payload);
    
  //       const success = navigator.sendBeacon(
  //         `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`,
  //         payload
  //       );
    
  //       if (!success) {
  //         console.warn('[UnityRoom] sendBeacon failed.');
  //       } else {
  //         console.log('[UnityRoom] sendBeacon payload sent successfully.');
  //       }
  //     } else {
  //       console.warn('[UnityRoom] Missing roomId or userId. Skipping payload on tab close.');
  //     }
  //   };
    
  //   window.addEventListener('beforeunload', handleTabClose);
    
  
  //   window.addEventListener('beforeunload', handleTabClose);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleTabClose);
  //   };
  // }, [roomId, userId]);
  
  
  
  

  if (!isValidSession) {
    return (
      <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <p>Session data is missing or invalid. Please navigate back to the Therapy Rooms.</p>
      </div>
    );
  }

//   return (
//     <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
    
  
//       <Navbar
//         setCurrentNickname={setCurrentNickname}
//         currentNickname={currentNickname}
//         setFormType={setFormType}
//         handleLogout={handleLogout}
//         showButtons={true}
//         PlutonicuserID={userId}
//       />

//       {/* <div style={{ flex: '0 0 120px' }}></div> Adds exactly 20px of space above the iframe */}

//       {roomUrl ? (
//         <iframe
//           id="unity-iframe"
//           src={roomUrl}
//           style={{ flex: 1, width: '100%', border: 'none' }}
          
//           title="Unity WebGL Build"
//           allow="fullscreen; camera; microphone; display-capture"
//           onLoad={() => {
//             console.log('[UnityRoom] Iframe loaded. Ready to send messages.');
//             const unityIframe = document.getElementById('unity-iframe');
//             if (unityIframe && unityIframe.contentWindow) {
//               const message = JSON.stringify({ userId, roomId }); // Serialize the message
//               console.log('[UnityRoom] Sending serialized message to Unity on load:', message);
//               unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
//             }
//           }}
//         />

//       ) : (
//         <p>Loading Unity Room...</p>
//       )}
//     </div>
//   );
// }

// export default UnityRoom;



return (
  <div style={{
    position: 'fixed', 
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
  }}>
  
    <Navbar
      setCurrentNickname={setCurrentNickname}
      currentNickname={currentNickname}
      setFormType={setFormType}
      handleLogout={handleLogout}
      showButtons={true}
      PlutonicuserID={userId}
    />

    <style>
      {`
        @media (min-width: 1400px) {
          #unity-iframe {
            position: fixed !important;
            top: 96px !important; /* 🚀 Pushes the Unity build down */
            left: 0 !important;
            width: 100vw !important; /* 🚀 Removes side spaces */
            height: calc(100vh - 95px) !important; /* Ensures full height */
            transform: scale(1) !important; /* Full size */
            transform-origin: center center !important;
          }
        }
      `}
    </style>

    {roomUrl ? (
      <iframe
        id="unity-iframe"
        src={roomUrl}
        style={{
          position: 'absolute',
          top: '80px',  // 🚀 Push the build down
          left: '0',
          width: '100vw',  // 🚀 Removes side spaces
          height: 'calc(100vh - 80px)',  // 🚀 Adjust height to keep full view
          border: 'none',
          display: 'block',
          overflow: 'hidden'
        }}
        title="Unity WebGL Build"
        allow="fullscreen; camera; microphone; display-capture"
        onLoad={() => {
          console.log('[UnityRoom] Iframe loaded. Ready to send messages.');
          const unityIframe = document.getElementById('unity-iframe');
          if (unityIframe && unityIframe.contentWindow) {
            const message = JSON.stringify({ userId, roomId }); // Serialize the message
            console.log('[UnityRoom] Sending serialized message to Unity on load:', message);
            unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
          }
        }}
      />
    ) : (
      <p>Loading Unity Room...</p>
    )}
  </div>
);
}

export default UnityRoom;

